import { AxiosInstance } from 'axios'

import { PaginateDTO } from '@shared/dto/PaginateDTO'

import { FindTransactionsPaginatedAIRequest, GetUsageAiRequest } from '@modules/ai/types/TransactionsAI/requests'
import { GetUsageAI, TransactionAI } from '@modules/ai/types/TransactionsAI/transactions'

export class AiTransactionsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async findPaginated(params: FindTransactionsPaginatedAIRequest): Promise<PaginateDTO<TransactionAI>> {
    const response = await this.instance.get(`/ai/transactions`, { params })

    return response.data
  }

  async getUsage(params: GetUsageAiRequest): Promise<GetUsageAI> {
    const response = await this.instance.get(`/ai/usage`, { params })

    return response.data
  }
}

export const aiTransactionsService = (instance: AxiosInstance) => new AiTransactionsService(instance)
